import Link from "next/link";

let packageJson = require("../package.json");

let city = packageJson.config.basePath;

export default function Custom404() {
  return (
    <section className="not-found">
      <div className="not-found__wrapper">
        <div className="not-found__number">404</div>
        <h1 className="not-found__title">
          Strona, której szukasz nie istnieje
        </h1>
        <Link
          href={"https://przyjazne-deklaracje.pl" + city}
          className="not-found__link"
        >
          Wróć na stronę główną
        </Link>
      </div>
    </section>
  );
}
